import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { Message } from "../models/message.model";
import { MessageService } from "../service/message.service";
import { MatIcon } from "@angular/material/icon";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { NgClass, NgFor, NgIf } from "@angular/common";

@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.scss"],
  imports: [NgClass, ExtendedModule, NgFor, NgIf, MatIcon],
})
export class MessageComponent implements OnDestroy {
  messages: Message[] = [];
  isVisibleMap: { [id: number]: boolean } = {}; // Map to track visibility of each message
  private messagesSubscription: Subscription;

  constructor(private messageService: MessageService) {
    this.messagesSubscription = this.messageService.currentMessages$.subscribe((messages) => {
      const nonBannerMessages = messages.filter((message) => !message.isBanner);

      nonBannerMessages.forEach((message) => {
        if (!this.isVisibleMap.hasOwnProperty(message.id)) {
          this.isVisibleMap[message.id] = false;
          setTimeout(() => (this.isVisibleMap[message.id] = true), 100); // Delay for slide-in effect
        }
      });
      this.messages = nonBannerMessages.slice(-10); // Keep only the last 10 messages
    });
  }

  closeMessage(id: number) {
    this.isVisibleMap[id] = false; // Start slide-out
    setTimeout(() => this.messageService.removeMessage(id), 500); // Wait for slide-out to finish
  }

  ngOnDestroy() {
    this.messagesSubscription.unsubscribe();
  }

  hiddenMessageContainer() {
    return (
      this.messages.length === 0 || this.messages.every((message) => !this.isVisibleMap[message.id])
    );
  }
}
